const dictionaries: { [key: string]: (page: string) => Promise<any> } = {
	'en-US': (page: string) => import(`./en-US/${page}.json`).then((module) => module.default),
	'nl-NL': (page: string) => import(`./nl-NL/${page}.json`).then((module) => module.default),
	'pt-PT': (page: string) => import(`./pt-PT/${page}.json`).then((module) => module.default),
};

export const getDictionary = async (locale?: string, page?: string) => {
	if (!locale || !page) {
		console.error('No locale or page provided');
		return {};
	} else {
		return dictionaries[locale]?.(page);
	}
};
